// extracted by mini-css-extract-plugin
export default {"input":"CampaignForm_input__-PnNz"};